/* eslint-disable array-callback-return */
import { put, call, takeLatest, all, fork } from "redux-saga/effects";
import { CLEAR_API_CALL_MESSAGE, GET_ALL_NEGOTIATION_CONTRACTS, GET_ALL_NEGOTIATION_CONTRACTS_FAILURE, GET_ALL_NEGOTIATION_CONTRACTS_SUCCESS, GET_BASIC_DETAILS_SUCCESS, GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS, GET_NEGOTIATION_TILE_DETAILS, GET_NEGOTIATION_TILE_DETAILS_FAILURE, GET_NEGOTIATION_TILE_DETAILS_SUCCESS, GET_POWER_POSITION_SUCCESS, GET_SELECTED_ACTION_TILES_SUCCESS, GET_TARGET_VALUE_DETAILS_SUCCESS, POST_DETAILED_NEGOTIATION_OVERVIEW, RESET_API_LOADER, SET_CLASSIFICATION_QUESTIONNAIRE, SET_CLASSIFICATION_TYPE, SET_IS_DATA_UPDATED, SET_POWER_POSITION } from "../Action/actionTypes";
import { apiCallFailure, apiCallRequest, apiCallSuccess } from "../Action/Action";
import * as dashboardAPI from '../../services/DashboardAPI';
import * as types from "../Action/actionTypes";

// worker saga
function* getNegotiationContractsForOverview(): Generator {
    try {
        yield put(apiCallRequest());
        const response: any = yield call(dashboardAPI.getNegotiationContractsAPI);
        if (response.status === 200) {
            yield put({ type: RESET_API_LOADER });
            yield put({ type: GET_ALL_NEGOTIATION_CONTRACTS_SUCCESS, payload: response.data.result })

        } else {
            yield put(apiCallFailure("Failed to fetch the negotiation contracts. Please try again."));
            yield put({ type: GET_ALL_NEGOTIATION_CONTRACTS_FAILURE, payload: "" })
        }
    } catch (error) {
        yield put(apiCallFailure("Failed to fetch the negotiation contracts. Please try again."));
    }
}

function* getReviewNegotiationData(): Generator {
    try {
        yield put(apiCallRequest());
        const response: any = yield call(dashboardAPI.getReviewNegotiationData);
        if (response.status === 200) {
            yield put({ type: types.GET_REVIEW_NEGOTIATION_DATA_SUCCESS, payload: response.data.result })

        } else {
            yield put({ type: types.GET_REVIEW_NEGOTIATION_DATA_FAILURE, payload: "" })
        }
    } catch (error) {

    }
}


// refactoring the negotiation contract data 
const __refactorNegotiationStepsData = (negotiationData: any) => {
    let basicDetailsArr = {
        negotiationName: negotiationData.basicDetails.name,
        leadCountry: negotiationData.basicDetails.leadCountryId,
        categoryName: negotiationData.basicDetails.categoryId,
        categoryCode: "",
        cluster: "",
        negotiationTeam: negotiationData.basicDetails.negotiationTeam,
        od: negotiationData.basicDetails.od,
        suppliers: negotiationData.basicDetails.supplierId,
        supplierLocation: "",
        salesRepLead: negotiationData.basicDetails.salesRepLeadId,
        additionalSalesRep: negotiationData.basicDetails.additionalSalesRep ? negotiationData.basicDetails.additionalSalesRep : "",
        negotiationDateMonth: negotiationData.basicDetails.negotiationDateMonth,
        negotiationDateYear: negotiationData.basicDetails.negotiationDateYear,
        negotiationImplementationMonth: negotiationData.basicDetails.negotiationImplementationMonth,
        negotiationImplementationYear: negotiationData.basicDetails.negotiationImplementationYear,
        validityPeriod: negotiationData.basicDetails.validityPeriod,
        relevantSpend: negotiationData.basicDetails.relevantSpend,
        comment: negotiationData.basicDetails.comment,
    };
    let powerPositionArr = {
        powerPositionData: {
            supplierExistOrNot: negotiationData.powerPosition.powerPositionQuestion1 != null ? JSON.stringify(negotiationData.powerPosition.powerPositionQuestion1) : "",
            supplierAwareness: negotiationData.powerPosition.powerPositionQuestion2 != null ? JSON.stringify(negotiationData.powerPosition.powerPositionQuestion2) : "",
            supplierDependent: negotiationData.powerPosition.powerPositionQuestion3 != null ? JSON.stringify(negotiationData.powerPosition.powerPositionQuestion3) : "",
        },
        powerPosition: negotiationData.powerPosition.powerPositionTitle,
        powerPositionId: negotiationData.powerPosition.powerPositionId
    };
    let salesRepArr = {
        classificationType: negotiationData.salesRepClassification.salesRepClassificationTitle ? negotiationData.salesRepClassification.salesRepClassificationTitle : "",
        salesRepClassificationId: negotiationData.salesRepClassification.salesRepClassificationId ? negotiationData.salesRepClassification.salesRepClassificationId : "",
        classificationSettings: negotiationData.salesRepClassification.classificationSettings !== "" ?
            JSON.parse(negotiationData.salesRepClassification.classificationSettings) : {},
    };
    let targetValueArr = {
        supplyDemand: negotiationData.targetValue.supplyDemandBalance,
        precursorCostChange: negotiationData.targetValue.precursorCostChanges,
        stopLimit: negotiationData.targetValue.stopLimit,
        goInPosition: negotiationData.targetValue.goinPosition,
        rounds: negotiationData.targetValue.negotiationRounds,
        NegotiationTarget: negotiationData.targetValue.negotiationTarget,
        paymentTerms: negotiationData.targetValue.paymentTerms,
        incoTerms: negotiationData.targetValue.incoTerms,
        localStock: negotiationData.targetValue.localStock,
    };

    let planNegotiationActionObj: any = {};

    negotiationData?.planNegotiationActions?.negotiationRoundsDetails?.length &&
        negotiationData?.planNegotiationActions?.negotiationRoundsDetails.map((data: any) => {
            let selectedArr: any = []
            data.selectedAction.length && data.selectedAction.map((selectedCard: any) => {
                selectedCard.inputText = selectedCard.implementationApproach;
                selectedArr.push(selectedCard)
            })
            planNegotiationActionObj[data.roundName] = selectedArr;
        })

    return { basicDetailsArr, powerPositionArr, salesRepArr, targetValueArr, planNegotiationActionObj }
}

function* getNegotiationContractTileData(action: any): Generator {
    try {
        yield put(apiCallRequest());
        const payload = action.payload.id;
        const contractStatus = action.payload.contractStatus;
        const isUpdated = Boolean(action.payload?.isUpdated);
        const response: any = yield call(dashboardAPI.getNegotiationContractDataAPI, payload);

        if (response.status !== 200) {
            yield put(apiCallFailure("Failed to fetch the negotiation contract data. Please try again."));
            yield put({ type: GET_NEGOTIATION_TILE_DETAILS_FAILURE });
            return;
        }

        yield put({ type: CLEAR_API_CALL_MESSAGE });

        if (contractStatus === "draft" || contractStatus === "inProgress") {
            yield* handleDraftOrInProgressFlow(response.data.result, contractStatus, isUpdated);
        } else {
            yield* handleClosedFlow(response.data.result);
        }

    } catch (error) {
        yield put(apiCallFailure("Failed to fetch the negotiation contract data. Please try again."));
    }
}

function* handleDraftOrInProgressFlow(result: any, contractStatus: string, isUpdated: boolean): Generator {
    const negotiationData = __refactorNegotiationStepsData(result);

    yield put({ type: GET_BASIC_DETAILS_SUCCESS, payload: negotiationData.basicDetailsArr });

    yield put({ type: GET_POWER_POSITION_SUCCESS, payload: negotiationData.powerPositionArr.powerPositionData });
    yield put({ type: SET_POWER_POSITION, payload: negotiationData.powerPositionArr.powerPosition });
    yield put({ type: types.SET_POWER_POSITION_ID, payload: negotiationData.powerPositionArr.powerPositionId });

    yield put({ type: SET_CLASSIFICATION_TYPE, payload: negotiationData.salesRepArr.classificationType });
    yield put({ type: SET_CLASSIFICATION_QUESTIONNAIRE, payload: negotiationData.salesRepArr.classificationSettings });
    yield put({ type: types.SET_SALES_REP_CLASSIFICATION_ID, payload: negotiationData.salesRepArr.salesRepClassificationId });

    yield put({ type: GET_TARGET_VALUE_DETAILS_SUCCESS, payload: negotiationData.targetValueArr });
    yield put({ type: GET_SELECTED_ACTION_TILES_SUCCESS, payload: negotiationData.planNegotiationActionObj });

    if (!isUpdated) {
        yield put({ type: GET_NEGOTIATION_TILE_DETAILS_SUCCESS });
    }

    if (contractStatus === "inProgress") {
        yield put({ type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS, payload: result });
        if (isUpdated) {
            yield put(apiCallSuccess("Your changes have been saved successfully."));
        }
    }
}

function* handleClosedFlow(result: any): Generator {
    yield put({ type: GET_NEGOTIATION_TILE_DETAILS_SUCCESS });
    yield put({ type: types.SET_CLOSE_NEGOTIATION_CONTRACT_DATA, payload: result });
}

function* saveDocumentOutcome(data: any): Generator {
    try {
        // API call or business logic here

        const response: any = yield call(dashboardAPI.saveDocumentOutcome, data)

        if (response.status === 200) {
            yield put(apiCallSuccess("Response saved successfully"));
            yield put({ type: types.SAVE_DOCUMENT_OUTCOME_SUCCESS, payload: response.result });
            if (data.meta?.onSuccess) {
                data.meta.onSuccess()
            }

        } else {
            yield put(
                apiCallFailure(
                    "An error occurred while saving your response. Please try again."
                )
            );
            yield put({ type: types.SAVE_DOCUMENT_OUTCOME_FAILURE, payload: "" });
            if (data.meta?.onFailure) {
                data.meta.onFailure()
            }
        }
    } catch (e) {
        yield put(
            apiCallFailure(
                "An error occurred while saving your response. Please try again."
            )
        );
        yield put({ type: types.SAVE_DOCUMENT_OUTCOME_FAILURE, payload: e });
        if (data.meta?.onFailure) {
            data.meta.onFailure()
        }
    }
}

function* saveDetailedNegotiationData(action: any): Generator {
    try {
        yield put(apiCallRequest())
        let payload = action.payload.roundCloseStatus ? action.payload.roundClose : action.payload;
        const response: any = yield call(dashboardAPI.saveDetailedNegotiationDataAPI, payload);
        if (response.status === 200) {
            yield put({ type: CLEAR_API_CALL_MESSAGE });
            if (!action.payload.roundCloseStatus) {
                yield put({ type: SET_IS_DATA_UPDATED, payload: true });
            }
        } else {
            yield put(apiCallFailure("Failed to save the negotiation contract data. Please try again."));
        }

    } catch (e) {
        yield put(apiCallFailure("Failed to save the negotiation contract data. Please try again."));
    }
}

// watch saga
function* watchGetNegotiationContractsForOverview(): Generator {
    yield takeLatest(GET_ALL_NEGOTIATION_CONTRACTS, getNegotiationContractsForOverview)
}
function* watchGetReviewNegotiationData(): Generator {
    yield takeLatest(types.GET_REVIEW_NEGOTIATION_DATA, getReviewNegotiationData)
}


function* watchGetNegotiationContractTileData(): Generator {
    yield takeLatest(GET_NEGOTIATION_TILE_DETAILS, getNegotiationContractTileData)
}
function* watchSaveDocumentOutcome(): Generator {
    yield takeLatest(types.SAVE_DOCUMENT_OUTCOME, saveDocumentOutcome)
}
function* watchSaveDetailedNegotiationData(): Generator {
    yield takeLatest(POST_DETAILED_NEGOTIATION_OVERVIEW, saveDetailedNegotiationData);
}
//root saga

export function* dashboardSaga(): Generator {
    yield all([
        fork(watchGetNegotiationContractsForOverview),
        fork(watchGetNegotiationContractTileData),
        fork(watchSaveDocumentOutcome),
        fork(watchSaveDetailedNegotiationData),
        fork(watchGetReviewNegotiationData),

    ])
}